import { HeaderService } from './../../services/header.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  menuItems: any[];

  constructor(private headerService: HeaderService) {

    this.menuItems = headerService.menu;
    // console.log(this.menuItems);

  }

  ngOnInit(): void {
  }

}
